import React, { useLayoutEffect } from 'react';
import { MagneticContainer, Tag } from './TagTheyAreIt.styles';
import { Avatar } from '@components/Avatar';
import ScrollMagic from 'scrollmagic';
import { gsap } from 'gsap';
import { useScrollController } from '@context/ScrollControllerProvider/useScrollController';
import { useIsMounted } from '@hooks/useIsMounted';

interface MagneticAvatarProps {
  avatarUrl: string;
  sizeVariant?: number;
  top: string;
  left: string;
  resTop: string;
  resLeft: string;
  resSizeVariant?: number;
}

export const MagneticAvatar: React.FC<MagneticAvatarProps> = ({ avatarUrl, sizeVariant, top, left, resTop, resLeft, resSizeVariant }) => {
  const values = { x: 0, y: 0, percent: 0, shouldMove: false };

  const magneticAvatarId = 'Magnetic_Avatar';
  const scrollController = useScrollController();
  const isMounted = useIsMounted();

  useLayoutEffect(() => {
    let scene: InstanceType<typeof ScrollMagic.Scene> | undefined;
    let timeline: ReturnType<typeof gsap.timeline>;
    if (scrollController && isMounted) {
      // Import Button animation
      timeline = gsap.timeline({ paused: true });
      timeline.to(`#${magneticAvatarId}`, { y: '30%' }, 0);
      scene = new ScrollMagic.Scene({
        triggerElement: `#Magnetic_Container`,
        triggerHook: 1,
        duration: '100%',
        offset: 600,
      })
        .addTo(scrollController)
        .on('progress', (event: ScrollMagic.SceneProgressEvent) => {
          timeline?.progress(event.progress);
        });
    }
    const clearScene = () => {
      if (timeline) {
        timeline.progress(0);
        timeline.kill();
      }
      if (scene) {
        scene.destroy(true);
      }
    };

    return clearScene;
  }, [scrollController, isMounted]);

  return (
    <MagneticContainer id={magneticAvatarId} resTop={resTop} resLeft={resLeft} top={top} left={left} values={values}>
      <Avatar
        src={avatarUrl}
        strokeWidth="2px"
        strokeColor={'purple2'}
        sizeVariant={`${sizeVariant}px`}
        resSizeVariant={`${resSizeVariant}px`}
      />
    </MagneticContainer>
  );
};
